


















































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import { solicitudes_cita_estado_hist } from "@/shared/dtos/solicitudes_cita_estado_hist";
import solicitudesCitaEstadoHistModule from "@/store/modules/solicitudes_cita_estado_hist-module";

@Component({ name: "SolicitudesCitaEstadoHistManager" })
export default class SolicitudesCitaEstadoHistManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;
  public searchText: string = "";
  public tipos: string[] = ["paciente", "admin", "sistema"];
  public form: solicitudes_cita_estado_hist = new solicitudes_cita_estado_hist();
  public headers: any[] = [
    { text: "ID", value: "id", width: "90px" },
    { text: "Solicitud", value: "id_solicitud", width: "120px" },
    { text: "Estado", value: "id_estado", width: "100px" },
    { text: "Tipo", value: "cambiado_por_tipo", width: "120px" },
    { text: "Comentario", value: "comentario" },
    { text: "Fecha", value: "created_at", width: "180px" },
    { text: "Acciones", value: "actions", sortable: false, width: "110px" }
  ];

  public mounted() { this.refresh(); }
  public get rows(): solicitudes_cita_estado_hist[] { return solicitudesCitaEstadoHistModule.rows; }
  public get filteredRows(): solicitudes_cita_estado_hist[] {
    const s = (this.searchText || "").toLowerCase().trim();
    if (!s) return this.rows;
    return this.rows.filter(x => (String(x.id_solicitud) + " " + (x.comentario || "")).toLowerCase().indexOf(s) !== -1);
  }
  public async refresh() { this.loading = true; try { await solicitudesCitaEstadoHistModule.getRows(); } finally { this.loading = false; } }
  public openCreate() { this.isEditMode = false; this.form = new solicitudes_cita_estado_hist(); this.form.cambiado_por_tipo = "sistema"; this.dialogOpen = true; }
  public openEdit(item: solicitudes_cita_estado_hist) { this.isEditMode = true; this.form = new solicitudes_cita_estado_hist(item); this.dialogOpen = true; }
  public async save() {
    if (this.form.id_solicitud <= 0 || this.form.id_estado <= 0) {
      MessageService.alert("Validacion", "ID solicitud e ID estado son obligatorios", MessageService.TypeWarning);
      return;
    }
    this.saving = true;
    try {
      this.form.comentario = (this.form.comentario || "").trim();
      if (this.isEditMode) await solicitudesCitaEstadoHistModule.modificar(this.form); else await solicitudesCitaEstadoHistModule.guardar(this.form);
      this.dialogOpen = false;
      await this.refresh();
    } finally { this.saving = false; }
  }
  public remove(item: solicitudes_cita_estado_hist) {
    MessageService.confirm("Quieres eliminar este registro?", "Confirmacion", async (res: boolean) => {
      if (!res) return;
      await solicitudesCitaEstadoHistModule.eliminar(item);
      await this.refresh();
    });
  }
}
